/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What can you do with GridCraft?`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 可以做什么？`)
};

/**
* | output |
* | --- |
* | "What can you do with GridCraft?" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_title as "gc.search_guides.what_is_gridcraft.sections.2.title" }